const isEditMode = () => document.body.classList.contains("mgnl-admin");
export default isEditMode;